import { render } from "./BalIcon.vue?vue&type=template&id=6633a068&ts=true"
import script from "./BalIcon.vue?vue&type=script&lang=ts"
export * from "./BalIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__